module.exports = __webpack_public_path__ + "static/img/3107_phase_function_Paper_PointsHejduk_Prediction.d07494c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3107_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 18l6
// module chunks = 0